<div
  [ngStyle]="{
    'border-color': borderColor,
    color: textAndIconColor,
    'background-color': backgroundColor
  }"
  class="mini-card"
>
  <mat-icon>{{ matIconName }}</mat-icon>
  <div class="text">
    {{ text }}
  </div>
</div>
